import { createLogger } from '@/logger';
import { getCurrentUser, getAuthenticatedUser } from './cognito';
import { listSessions } from './session';
import friendly from './errors';

const log = createLogger('auth.logout');

function forgetAllSessions(user, next) {
  const noop = {
    onSuccess: () => {},
    onFailure: () => {},
  };

  listSessions({
    count: 50,
    error: next,
    success: ({ sessions, fetchMore }) => {
      sessions.forEach(session => user.forgetSpecificDevice(session.key, noop));
      if (fetchMore) {
        fetchMore();
      } else {
        next();
      }
    },
  });
}

export function logout() {
  const user = getCurrentUser();

  if (user) {
    log.information({ message: 'User logged out.' });
    user.signOut();
  }
}

export function globalLogout({ success, error }) {
  getAuthenticatedUser({
    error: err => error(friendly(err, log)),
    success: ({ user }) => {
      // forget sessions before clearing tokens (session must be valid)
      forgetAllSessions(user, () => {
        // then sign out
        log.information({ message: 'User invalidated all sessions.' });
        user.globalSignOut({
          onFailure: err => error(friendly(err, log)),
          onSuccess: () => {
            logout();
            success();
          },
        });
      });
    },
  });
}



// WEBPACK FOOTER //
// ./src/auth/logout.js